import { __assign, __extends, __rest, __spreadArray } from "tslib";
import React from "react";
import PnmacTable from "../../Table/PnmacTable";
import PnmacRow from "../../Table/PnmacRow";
import { Image, Text, TouchableOpacity, View } from "react-native";
import styles from "../PnmacMessageCenter.styles.js";
import { PnmacUIButton } from "../..";
import Compose from "./Compose";
import PnmacText from '../../Typography/PnmacText';
import { textStyle } from '../../v2/theme';
var Row = function (_a) {
  var index = _a.index,
    newData = _a.newData,
    hasAttachment = _a.hasAttachment,
    rowData = _a.rowData,
    messageShowing = _a.messageShowing,
    props = __rest(_a, ["index", "newData", "hasAttachment", "rowData", "messageShowing"]);
  var row = __spreadArray([], rowData, true);
  var update = function () {
    row = rowData;
    messageShowing();
  };
  if (row.length > 3) {
    row.pop();
  }
  var st = styles.tableText;
  if (!newData) {
    st = {
      margin: 10,
      color: "#003087",
      fontWeight: '800'
    };
  }
  if (hasAttachment) {
    row[0] = /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: 'Attachment',
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        width: 15,
        height: 15,
        margin: 5
      },
      source: require("../../assets/paperclip.png")
    }), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, null, row[0])));
  }
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    accessible: true,
    accessibilityLabel: 'update button',
    onPress: function () {
      return update();
    }
  }, /*#__PURE__*/React.createElement(PnmacRow, {
    noBorder: true,
    flexArr: [1, 1, 1, 1],
    data: row,
    textStyle: st
  }));
};
var Inbox = /** @class */function (_super) {
  __extends(Inbox, _super);
  function Inbox(props) {
    var _this = _super.call(this, props) || this;
    _this.markMessageRead = function () {
      var markRead = _this.props.markRead;
      var _a = _this.state,
        showing = _a.showing,
        tdata2 = _a.tdata2;
      if (showing >= 0 && showing < (tdata2 === null || tdata2 === void 0 ? void 0 : tdata2.length)) {
        var messageId = tdata2[showing];
        if ((messageId === null || messageId === void 0 ? void 0 : messageId.length) > 0 && !messageId[7]) {
          _this.setState(markRead(messageId));
        }
      }
    };
    _this.state = {
      showing: -1,
      tdata2: __spreadArray([], props.tableData, true)
    };
    return _this;
  }
  Inbox.getDerivedStateFromProps = function (props, state) {
    if (props.tableData != state.tdata2) {
      return __assign(__assign({}, state), {
        tdata2: __spreadArray([], props.tableData, true)
      });
    }
    return null;
  };
  Inbox.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      loanId = _b.loanId,
      setReply = _b.setReply,
      deleteColor = _b.deleteColor,
      replyColor = _b.replyColor,
      closeColor = _b.closeColor,
      unReadColor = _b.unReadColor,
      markRead = _b.markRead,
      reply = _b.reply,
      customerName = _b.customerName,
      tableHead = _b.tableHead,
      tableData = _b.tableData,
      deleteItem = _b.deleteItem,
      gridNoItemsText = _b.gridNoItemsText,
      small = _b.small,
      medium = _b.medium,
      large = _b.large,
      isPennyWiseMode = _b.isPennyWiseMode,
      rest = __rest(_b, ["loanId", "setReply", "deleteColor", "replyColor", "closeColor", "unReadColor", "markRead", "reply", "customerName", "tableHead", "tableData", "deleteItem", "gridNoItemsText", "small", "medium", "large", "isPennyWiseMode"]);
    var rowdatas;
    var me;
    if (this.state.showing > -1) {
      rowdatas = this.state.tdata2[this.state.showing];
      me = /*#__PURE__*/React.createElement(View, {
        style: {
          borderBottomWidth: 1,
          borderBottomColor: "#EFEFEF"
        }
      }, rowdatas ? rowdatas[4] : null);
    }
    return /*#__PURE__*/React.createElement(PnmacTable, {
      style: {
        backgroundColor: reply ? "transparent" : "#FFF",
        borderRadius: 10,
        marginTop: -1,
        shadowColor: "rgba(0,0,0, .08)",
        shadowOffset: {
          height: 4,
          width: 2
        },
        shadowOpacity: 1,
        shadowRadius: 12
      }
    }, this.state.showing == -1 ? /*#__PURE__*/React.createElement(PnmacRow, {
      flexArr: [1, 1, 1, 1],
      data: tableHead || [],
      style: {
        backgroundColor: "#EFEFEF"
      },
      textStyle: [styles.tableTextHead, textStyle.defaultTextTitle]
    }) : /*#__PURE__*/React.createElement(View, null), this.state.showing == -1 ? (tableData || []).length > 0 ? tableData.map(function (rowData, index) {
      var v2rowData = __spreadArray([], rowData, true);
      v2rowData.splice(5, 5);
      return /*#__PURE__*/React.createElement(View, {
        key: index,
        style: {
          backgroundColor: index % 2 === 0 ? "#FFF" : "#EFEFEF",
          borderBottomLeftRadius: index === tableData.length - 1 ? 10 : 0,
          borderBottomRightRadius: index === tableData.length - 1 ? 10 : 0
        }
      }, /*#__PURE__*/React.createElement(Row, __assign({
        hasAttachment: rowData[9],
        newData: rowData[7],
        messageShowing: function () {
          _this.setState({
            showing: index
          }, markRead(rowData));
        }
      }, rest, {
        rowData: v2rowData
      })));
    }) : (/*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: gridNoItemsText || "No items to display",
      style: {
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, gridNoItemsText || "No items to display"))) : reply ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Compose, __assign({}, rest, {
      small: small,
      cancel: function () {
        return setReply(null);
      },
      reply: true,
      rowdata: rowdatas
    }))) : /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacRow, {
      noBorder: true,
      flexArr: [1],
      data: [me],
      style: {},
      textStyle: styles.tableText
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: small ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: small ? "100%" : "50%",
        marginVertical: 40
      }
    }, rowdatas && !((_a = rowdatas[2]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("automated")) ? /*#__PURE__*/React.createElement(View, {
      style: {
        width: small ? "100%" : "auto",
        marginRight: small ? 0 : 20,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      hoverColor: "white",
      accessibilityLabel: 'Reply button',
      mode: "contained",
      style: {
        marginBottom: 10
      },
      onPress: function () {
        return setReply(rowdatas);
      }
    }, "Reply")) : null, /*#__PURE__*/React.createElement(View, {
      style: {
        width: small ? "100%" : "auto",
        marginRight: small ? 0 : 20,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      hoverColor: "white",
      mode: "contained",
      accessibilityLabel: 'Delete button',
      style: {
        marginBottom: 10
      },
      disabled: isPennyWiseMode,
      onPress: function () {
        return deleteItem(rowdatas, function () {
          return _this.setState({
            showing: -1
          });
        });
      }
    }, "Delete")), /*#__PURE__*/React.createElement(View, {
      style: {
        width: small ? "100%" : "auto",
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      hoverColor: "white",
      accessibilityLabel: 'Close button',
      mode: "outlined",
      style: {
        marginBottom: 10
      },
      onPress: function () {
        return _this.setState({
          showing: -1
        });
      }
    }, "Close"))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: small ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: small ? "100%" : "25%"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      disabled: this.state.showing === 0,
      hoverColor: "white",
      mode: "contained",
      accessibilityLabel: 'Previous Message button',
      style: {
        width: "100%",
        marginBottom: 10
      },
      onPress: function () {
        if (_this.state.showing > 0) {
          _this.setState(function (prevState) {
            return {
              showing: prevState.showing - 1
            };
          }, function () {
            _this.markMessageRead();
          });
        }
      }
    }, "<< Previous Message")), /*#__PURE__*/React.createElement(View, {
      style: {
        width: small ? "100%" : "25%"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      disabled: this.state.showing === tableData.length - 1,
      hoverColor: "white",
      mode: "contained",
      accessibilityLabel: 'Next Message button',
      style: {
        width: "100%",
        marginBottom: 10
      },
      onPress: function () {
        if (_this.state.showing !== tableData.length - 1) {
          _this.setState(function (prevState) {
            return {
              showing: prevState.showing + 1
            };
          }, function () {
            _this.markMessageRead();
          });
        }
      }
    }, "Next Message >>"))), /*#__PURE__*/React.createElement(View, {
      accessible: true,
      accessibilityLabel: "Message ".concat(this.state.showing + 1, " of ").concat(tableData.length),
      style: {
        marginTop: 20,
        width: "100%",
        display: "flex",
        alignItems: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, "Message ", this.state.showing + 1, " of ", tableData.length)))));
  };
  return Inbox;
}(React.Component);
export default Inbox;